import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { isValid } from "iban";

/**
 * InputOrderFormField for any form.
 */

 const regexes = {
 	'email': /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
 	'date': /^(0[1-9]|1[0-2]).([1-9]|[12][0-9]|3[01]).(\d{4})$/i,
 	'number': /^\d+$/
 };
 const errors = {
 	'email': 'Bitte geben Sie eine gültige Email-Adresse an.',
 	'date': 'Bitte geben Sie ein gültiges Datum an (TT.MM.JJJJ).',
 	'number': 'Bitte nur Zahlen eingeben.'
 };

class InputOrderFormField extends React.Component {
	constructor(props) {
	    super(props);
	    this.onFocus = this.onFocus.bind(this);
	    this.onChange = this.onChange.bind(this);
	    this.doVerify = this.doVerify.bind(this);
	    this.state = {isFocused: false, isFilled: false, hasError: false, errorMsg:''};

	}
	componentDidMount() {
		if(this.props.value!=='') {
			this.fieldInput.value = this.props.value;
		}
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		
	}
	onFocus(e) {
		this.setState({isFocused: true});
	}
	onChange(e) {
		this.setState({isFocused: false});
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		this.doVerify();
	}
	doVerify() {
		var hasError = false, errorMsg = '', currentValue = this.fieldInput.value.trim();
		if(this.props.required && currentValue==='') {
			hasError = true;
			errorMsg = 'Dieses Feld wird benötigt.';
		} else if(currentValue!=='' && this.props.verify!=='') {
			if(this.props.verify==='iban') {
				if(!isValid(currentValue)) {
					hasError = true;
					errorMsg = 'Bitte überprüfen Sie die IBAN.';
				}
			} else if(this.props.verify==='hausnummer') {
				if(currentValue.replace(/[^\w\s]/gi,'')==="") {
					hasError = true;
					errorMsg = 'Bitte überprüfen Sie die Hausnummer.';
				}
			} else {
				if(currentValue.match(regexes[this.props.verify])===null) {
					hasError = true;
					errorMsg = errors[this.props.verify];
		        }
			}
		}
		this.setState({hasError: hasError, errorMsg: errorMsg});
		this.props.onChange(this.fieldInput, hasError, this.props.itemkey);
	}
    render () {
    	const id = uniqueId('input_'); 
		const classNames = (this.state.isFocused?"focused ":"")+(this.state.isFilled?"filled ":"")+(this.state.hasError?"error ":"")+"inputfield "+this.props.name
		return (
			<div className={classNames}>
				{this.props.name!=="hausnummer" ? <input autoCapitalize="off" autoCorrect="off" id={id} type={this.props.type} name={this.props.name} onFocus={this.onFocus} onChange={this.onChange} ref={(input) => { this.fieldInput = input; }}  /> : 
				<input autoCapitalize="off" autoComplete="off" autoCorrect="off" id={id} type={this.props.type} name={this.props.name} onFocus={this.onFocus} onChange={this.onChange} ref={(input) => { this.fieldInput = input; }}  />
				}
				

				
				<label htmlFor={id}>{this.props.label}{this.props.required?"*":""}</label>
				{this.state.hasError && this.state.errorMsg!==''?<div className="errormsg">{this.state.errorMsg}</div>:null}
			</div>
		)
    }

}
InputOrderFormField.propTypes = {
	/** InputOrderFormField Type */
	type: PropTypes.oneOf(['text','email','search','password','tel']),
	/** InputOrderFormField verify */
	verify: PropTypes.string,
	/** InputOrderFormField required */
	required: PropTypes.bool,
	/** InputOrderFormField value */
	value: PropTypes.string,
	/** InputOrderFormField value */
	itemkey: PropTypes.string,
	/** InputOrderFormField Label */
	label: PropTypes.string.isRequired,
}


InputOrderFormField.defaultProps = {
  type: "text",
  verify: "",
  value: "",
  itemkey: "",
  required: false
}

export default InputOrderFormField;


// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormField.js